export enum TABBAR_BLOCKER_ID {
  // AQUI VAN LOS BLOCKERS DE TABS
}
